export enum TranslationsKeys {
  // Global
  TERMS = 'terms',
  COMMON = 'common',
  OLD_TRANSLATIONS = 'translation',
  // Peticiones
  PETITIONS = 'petitions',
  SURVEY = 'survey',
  // announcements
  ANNOUNCEMENTS_LIST = 'announcements/list',
}

export const TranslatonsArray = Object.values(TranslationsKeys);
